import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'

// Material icons
import 'material-design-icons-iconfont/dist/material-design-icons.css'

// vue awesome swiper
import VueAwesomeSwiper from 'vue-awesome-swiper'
// require styles
import 'swiper/dist/css/swiper.css'

import VueYouTubeEmbed from 'vue-youtube-embed'

// font awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// Vuetify
import 'vuetify/dist/vuetify.min.css'
import Vuetify from 'vuetify'
// import VuePapaParse from 'vue-papa-parse'

// VueLazyLoad
import VueLazyLoad from 'vue-lazyload'
// import spinner from './assets/spinner.gif'

Vue.use(Vuetify)
Vue.use(VueAwesomeSwiper)
Vue.use(VueYouTubeEmbed)
// Vue.use(VuePapaParse)
Vue.use(VueLazyLoad)

library.add(faChevronLeft)
library.add(faChevronRight)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  next()
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
